import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2518">
      <Navbar data-id="element-2519" />
      <main data-id="element-2520">
        <ConsularAffairs data-id="element-2521" />
      </main>
      <Footer data-id="element-2522" />
      <FeedbackPopup data-id="element-2523" />
    </div>;
}